<template>
  <div class="category">
    <ul class="nav nav-pills">
      <li class="nav-item">
        <a class="nav-link" href="#" @click.prevent="handleClickItem('')">全部</a>
      </li>
      <li class="nav-item" v-for="item in list" :key="item">
        <a class="nav-link" href="#" @click.prevent="handleClickItem(item)">{{item}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Category',
  props: {
    list: Array,
  },
  methods:{
    handleClickItem(category){
      this.$emit("search",{category:category});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
